import type { Dispatch } from 'redux';
import { createSelector } from 'reselect';
import DirectoryBase from '@atlassian/jira-directory-base/src/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { ITEMS_PER_PAGE } from '../model/constants.tsx';
import type { Query } from '../model/index.tsx';
import {
	patch as patchComponent,
	retrieve as retrieveComponents,
} from '../state/actions/filters/index.tsx';
import { patchQuery } from '../state/actions/query/index.tsx';
import { isWithoutHeader } from '../state/selectors/app/index.tsx';
import { getIds, getTotal, isLoading, isError } from '../state/selectors/filters/index.tsx';
import {
	getSortField,
	getSortDirection,
	getPage,
	getFilter,
	isFilterApplied,
} from '../state/selectors/query/index.tsx';
import type { State, Action } from '../state/types.tsx';
import EmptyView from './content/empty/view.tsx';
import ErrorView from './content/error/index.tsx';
import FilterView from './content/filter/index.tsx';
import {
	operationModals,
	emptyFilterResultConfiguration,
	getHeaderConfiguration,
	getTableConfiguration,
	getTableLabel,
	getResultsAnnouncerMessage,
} from './selectors.tsx';

const getHeaderConfigurationMemoized = () =>
	createSelector(
		(state: State) =>
			isWithoutHeader(state) ? { FilterView } : { headerConfiguration: getHeaderConfiguration() },
		(res) => res,
	);
const mapStateToPropsFactory = () => {
	const getHeaderConfigurationInstance = getHeaderConfigurationMemoized();
	return (state: State) => ({
		// data
		entityIds: getIds(state),
		totalItems: getTotal(state),
		itemsPerPage: ITEMS_PER_PAGE,
		isLoading: isLoading(state),
		isError: isError(state),
		page: getPage(state),
		sortField: getSortField(state),
		sortDirection: getSortDirection(state),
		filter: isFilterApplied(state) ? getFilter(state) : undefined,

		// ui
		firstColumnHeadingAlignment: 'center',

		// views
		...getHeaderConfigurationInstance(state),
		tableConfiguration: getTableConfiguration(state),
		tableLabel: getTableLabel(),
		resultsAnnouncerMessage: getResultsAnnouncerMessage(),

		emptyFilterResultConfiguration,
		operationModals,
		EmptyView,
		ErrorView,
	});
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
	// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'patch' implicitly has an 'any' type.
	onPatch: ({ id, patch }) => dispatch(patchComponent({ id, patch })),
	onReload: (query: Partial<Query>) => {
		dispatch(patchQuery(query));
		dispatch(retrieveComponents());
	},
});

export default connect(
	mapStateToPropsFactory,
	mapDispatchToProps,
	// @ts-expect-error - TS2345 - Argument of type 'typeof Directory' is not assignable to parameter of type 'Component<({ tableConfiguration: ({ title: () => Element; Cell: any; sortField: "favourite"; width: number; dataTestId?: undefined; } | { title: MessageDescriptorV2; Cell: any; sortField: "name"; width: number; dataTestId?: undefined; } | ... 4 more ... | undefined)[]; ... 15 more ...; firstColumnHeadingAlignment: s...'.
)(DirectoryBase);
